import list from './list'
import show from './show'
import del from './delete'

export default {
  namespaced: true,
  modules: {
    list,
    show,
    del
  }
}
